import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { noop } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useModal } from "../../../../utils/hooks/useModal";

const icon = (
    <FontAwesomeIcon
        icon={faCircleExclamation}
        className="text-primary w-100 mb-5"
        fontSize={70}
    />
);

export const useConfirmModal = ({
    message,
    onConfirm,
    onCancel = noop,
}) => {
    const { t } = useTranslation();

    const head = useMemo(() => (
        <h2 className="mb-0 text-center font-weight-bolder">
            {t("are-you-sure")}
        </h2>
    ), [t]);

    return useModal({
        head,
        icon,
        message,
        color: "primary",
        onConfirm,
        onCancel,
    });
};
